// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export * from '../exports';
export * from '/home/runner/work/dialog/dialog/node_modules/dumi/dist/client/theme-api/index.js';
export * from './meta/exports';
